import React, { useState, useEffect } from 'react';
import './App.css';
import OnboardingFlow from './components/OnboardingFlow';

function App() {
  return (
    <div className="App">
      <OnboardingFlow />
    </div>
  );
}

export default App;